"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CardRowContext = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _jsxRuntime = require("react/jsx-runtime");

var CardRowContext = /*#__PURE__*/(0, _react.createContext)(null);
exports.CardRowContext = CardRowContext;

var CardRowProvider = function CardRowProvider(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(CardRowContext.Provider, {
    value: {
      isOpen: isOpen,
      setIsOpen: setIsOpen
    },
    children: children
  });
};

var _default = CardRowProvider;
exports.default = _default;